export default function (context) {
	// If the user is not authenticated
	if (!context.$cookie.get('agentToken')) {
		return context.redirect('/agent/login');
	}
}